import axios from 'axios';

const api = axios.create({
  baseURL: 'https://integrate.leadflow.digital',
  // baseURL: 'http://localhost:3333',
});

export default api;
